import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { padding, TPaddingParams } from '@hfs/ui/utils/style/padding'

type TProps = TPaddingParams &
  Pick<
    FontAwesomeIconProps,
    | 'border'
    | 'className'
    | 'color'
    | 'fixedWidth'
    | 'flip'
    | 'icon'
    | 'inverse'
    | 'listItem'
    | 'mask'
    | 'onClick'
    | 'pull'
    | 'pulse'
    | 'rotation'
    | 'size'
    | 'spin'
    | 'swapOpacity'
    | 'transform'
  >

const BaseIcon = styled(FontAwesomeIcon)<TProps>`
  ${padding}
`

export const Icon = (props: TProps) => <BaseIcon {...props} />
